function setCookie( name, value, days ) {
	const d = new Date();
	d.setTime( d.getTime() + ( days * 24 * 60 * 60 * 1000 ) );
	document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/';
}

function getCookie( name ) {
	const n = name + '=';
	const ca = document.cookie.split( ';' );
	for ( let i = 0; i < ca.length; i++ ) {
		const c = ca[ i ].trim();
		if ( c.indexOf( n ) === 0 ) {
			return c.substring( n.length );
		}
	}
	return null;
}

jQuery( function() {
	if ( jQuery( window ).width() > 768 ) {
		return;
	}

	const bar = jQuery( '#top-bar-ajax' );

	if ( ! getCookie( 'topbar_closed' ) ) {
		bar.addClass( 'active' );
		jQuery( 'body' ).removeClass( 'hide-topbar' );
	}

	jQuery( '.topbar-close' ).on( 'click', function() {
		bar.removeClass( 'active' );
		jQuery( 'body' ).addClass( 'hide-topbar' );
		setCookie( 'topbar_closed', '1', 30 );
	} );
} );
